import "lazysizes";

import { onDocumentReady } from "./utils/document-ready";

import Link from "./components/link";
import Section from "./components/section";
import Dialog from "./components/dialog";
import { ClientComponentManager } from "./utils/client-component-manager";

onDocumentReady(() => {
  /**
   * Synchronous components: Import and use the class.
   * @example new ClientComponentManager(Component, "selector");
   */
  new ClientComponentManager(Link, "a");
  new ClientComponentManager(Dialog, ".js--dialog");
  new ClientComponentManager(Section, ".js--section");

  /**
   * Asynchronous components: Provide file handle in /js/components/ directory.
   * @example new ClientComponentManager('component', "selector");
   */
  new ClientComponentManager("grid", ".js--grid");
  new ClientComponentManager("dropdown", ".js--dropdown");
  new ClientComponentManager("tabs", ".js--tabs");
  new ClientComponentManager("book-spread", ".js--book-spread");
  new ClientComponentManager("video", ".js--video");
  new ClientComponentManager("expand", ".js--expand");
  new ClientComponentManager("search", ".js--search");
  new ClientComponentManager("marquee", ".js--marquee");
  new ClientComponentManager("select-sync", ".js--select-sync");
  new ClientComponentManager("scroll-top", ".js--scroll-top");
  new ClientComponentManager("watch-intersect", ".js--watch-intersect");
});
